import React, {useState} from "react";
import {Col, Flex, Form, Input, Row, Space, Button, Descriptions, DescriptionsProps, Badge, Image, message} from "antd";
import {Card} from "react-bootstrap";
import './../../styles/mojeZgloszenie.css';
import {Link} from "react-router-dom";
import NoweZgloszenieLayaut from "./../noweZgloszenie/NoweZgloszenieLayaut";
import {getMojeZgloszenie} from "./mojeZgloszenieServices";
import {iconTyp, isEmpty, statusyType} from "../../GlobalServices";
import dayjs from "dayjs";
import {downloadFile} from "../adminPanel/Services";
import axios from "axios";
import {HOST_API} from "../../AppConfig";
import Komentarze from "../adminPanel/panel/component/Komentarze";
const { TextArea } = Input;

const MojeZgloszenieMain = () => {
    const [szukanie, setSzukanie] = useState(false);
    const [odnalezione, setOdnalezione] = useState(false);
    const [mojeZgloszenie, setMojeZgloszenie]: any = useState();
    const [currentImage, setCurrentImage] = useState(0);
    const [images, setImages] = useState([]);
    const [visible, setVisible] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const onZnajdz = (form: any) => {
        setSzukanie(true);
        getMojeZgloszenie(form.numer, form.haslo).then((response) => {
            setSzukanie(false);

            if(isEmpty(response.data.zgloszenie)){
                messageApi.open({
                    type: 'error',
                    content: 'Nie znaleziono zgłoszenia. Sprawdź poprawność numeru oraz hasła.',
                    duration: 5,
                });
            } else {
                setOdnalezione(true);
                setMojeZgloszenie(response.data);
            }

        }).catch((error) => {
            setSzukanie(false);
        })
    }

    const onClickFile = (plik: any, pliki: any) => {
        if(images.length < 1){
            let zdj: any = [];
            let ile = pliki.filter((p: any) => p.typ.indexOf('jpeg') !== -1 || p.typ.indexOf('image') !== -1).length;

            pliki.forEach( (p: any) => {
                if(p.typ.indexOf('jpeg') !== -1 || p.typ.indexOf('image') !== -1) {
                    axios({
                        method: 'GET',
                        url: HOST_API + 'plik/get/' + p.id,
                        responseType: 'blob',
                        // headers: {'Authorization': 'Basic ' + JSON.parse(localStorage.userLoggedZgloszenia).credentials}
                    }).then((response) => {
                        zdj.push({
                            src: URL.createObjectURL(response.data),
                            caption: p.nazwa,
                            id: p.id
                        });
                        ile--;
                        if(ile === 0){
                            zdj = [...zdj].sort((a, b) => a.id - b.id);
                            setImages(zdj);
                            // console.log('pobralem')
                            setVisible(true);
                        }
                    })
                }
            });

        } else {
            setVisible(true);
        }
    }

    const getLabelByValue = (value: string) => {
        const foundStatus = statusyType.find(status => status.value === value);
        return foundStatus ? foundStatus.label : 'Nieznany status';
    }

    const getStatusByValue = (value: string) => {
       switch (value) {
           case 'nowe': return 'warning'
           case 'wTrakcie': return 'processing'
           case 'zamkniete': return 'default'
           default: return 'error'
       }
    }

    const items: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Imię i nazwisko',
            children: <>{mojeZgloszenie?.zgloszenie?.imie} {mojeZgloszenie?.zgloszenie?.nazwisko}</>,
            // span: 1
        },
        {
            key: '2',
            label: 'E-mail',
            children: mojeZgloszenie?.zgloszenie?.email,
        },
        {
            key: '3',
            label: 'Data wpisu',
            children: dayjs(mojeZgloszenie?.zgloszenie?.dataWpisu).format('YYYY-MM-DD HH:mm'),
        },
        {
            key: '4',
            label: 'Status',
            children: <Badge status={getStatusByValue(mojeZgloszenie?.zgloszenie?.status)} text={getLabelByValue(mojeZgloszenie?.zgloszenie?.status)} />,
            span: 3,
        },
        {
            key: '5',
            label: 'Kogo dotyczy',
            children: mojeZgloszenie?.zgloszenie?.kogoDotyczy,
            // span: 2
        },
        {
            key: '6',
            label: 'Miejsce',
            children: mojeZgloszenie?.zgloszenie?.miejsce,
            // span: 2
        },
        {
            key: '7',
            label: 'Kiedy',
            children: isEmpty(mojeZgloszenie?.zgloszenie?.dataOd) || isEmpty(mojeZgloszenie?.zgloszenie?.dataOd) ?
                null
                :
                <>{dayjs(mojeZgloszenie?.zgloszenie?.dataOd).format('YYYY-MM-DD')} - {dayjs(mojeZgloszenie?.zgloszenie?.dataDo).format('YYYY-MM-DD')}</>
            // span: 2
        },
        {
            key: '8',
            label: 'Opis sytuacji',
            children: mojeZgloszenie?.zgloszenie?.opis,
            span: 3
        },
        {
            key: '9',
            label: 'Dokumentacja',
            children: <>{mojeZgloszenie?.pliki.length > 0 ? <div className={'col-md-12'}>
                {mojeZgloszenie.pliki.map((plik: any, index: number) => {
                    if(plik.typ.indexOf('jpeg') !== -1 || plik.typ.indexOf('image') !== -1){
                        return <div className={'fileDokumentacja'} onClick={() => {
                            setCurrentImage(index);
                            onClickFile(plik, mojeZgloszenie?.pliki);
                        }}>
                            {iconTyp(plik.typ)} {plik.nazwa} ({parseFloat(plik.rozmiar) / 1000} kb)
                        </div>
                    } else {
                        return <div className={'fileDokumentacja'} onClick={() => downloadFile(plik)}>
                            {iconTyp(plik.typ)} {plik.nazwa} ({parseFloat(plik.rozmiar) / 1000} kb)
                        </div>
                    }
                })}
            </div> : null}</>,
        },
    ];

    return (<NoweZgloszenieLayaut>
            {odnalezione ?
                <div style={{paddingTop: '25px'}}>
                    <Descriptions title={`Zgłoszenie numer ${mojeZgloszenie?.zgloszenie?.numer}`} bordered items={items} size={'small'} />
                    <Image.PreviewGroup
                        preview={{
                            visible,
                            onChange: (current, prev) => setCurrentImage(current),
                            onVisibleChange: (value) => {
                                setVisible(value);
                            },
                            current: currentImage
                        }}
                    >
                        {images.map((plik: any, index: number) => <Image style={{display: 'none'}} src={plik.src}/>)}
                    </Image.PreviewGroup>
                    <Komentarze komentarze={mojeZgloszenie?.komentarz}/>
                </div>
                :
                <Flex gap="middle" align="center" vertical style={{padding: '5px'}}>
                <div style={{padding: '150px 15px'}}>
                    <h3 style={{marginBottom: 0}}>Znajdź swoje zgłoszenie</h3>
                    <p>Podaj numer zgłoszenia oraz hasło aby wyszukać swoje zgłoszenie.</p>
                    <Card>
                        <Card.Body>
                            {/*<p>Podaj numer zgłoszenia oraz hasło aby wyszukać swoje zgłoszenie.</p>*/}
                            <Form
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                layout="vertical"
                                onFinish={onZnajdz}
                                // style={{ maxWidth: 800 }}
                            >
                                <Row gutter={16}>
                                    <Col xl={24}>
                                        <Form.Item label="Numer zgłoszenia" name={'numer'} wrapperCol={{span: 24}} rules={[{ required: true, message: 'Pole wymagane' }]}>
                                            <Input maxLength={100} />
                                        </Form.Item>
                                        <Form.Item label="Hasło" name={'haslo'} wrapperCol={{span: 24}} rules={[{ required: true, message: 'Pole wymagane' }]}>
                                            <Input maxLength={100} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit" loading={szukanie} disabled={szukanie}>
                                                Znajdź
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
                </Flex>
            }
            {contextHolder}
    </NoweZgloszenieLayaut>
    )
}

export default MojeZgloszenieMain;
